import {
    DeliveryTimeOffer,
    Time,
} from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/types'
import dayjs from 'dayjs'
import { useMemo } from 'react'

const isToday = (day: string): boolean => dayjs(day).isSame(dayjs(), 'day')

export const useAvailableTimes = (deliveryTimeOffer: DeliveryTimeOffer, day?: string): Time[] => {
    return useMemo(() => {
        if (!day) return []

        const dayStartTimestamp = dayjs(day).startOf('day').valueOf()

        const times: Time[] =
            deliveryTimeOffer.timed?.options
                .filter(
                    (option) => dayjs(option.start).startOf('day').valueOf() === dayStartTimestamp
                )
                .map((option) => ({ timed: option })) ?? []

        if (deliveryTimeOffer.asap && isToday(day)) times.unshift({ asap: deliveryTimeOffer.asap })

        return times
    }, [deliveryTimeOffer, day])
}
